import FormMultiSelect from "./FormMultiSelect";
import { memo } from "react";

const BrandProductSection = ({ brands, products, project, updateProject }) => {
  return (
    <>
      <FormMultiSelect
        label="Brands"
        value={project?.brands}
        options={brands}
        onChange={(selected) => updateProject("brands", selected)}
      />

      <FormMultiSelect
        label="Products"
        value={project.products}
        options={products}
        onChange={(selected) => updateProject("products", selected)}
      />
    </>
  );
};

export default memo(BrandProductSection);
